import { createReducer, on } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { SobreJornalOutputDto } from "src/app/domain/DTOs/output/sobre/sobre-jornal.output.dto";
import { obterSobre, obterSobreSuccess } from "../../actions/Sobre/obter-sobre.action";

export interface ObterSobreState {
    response: EstruturaRetornoDadosOutputDto<SobreJornalOutputDto> | null;
    error: string[] | null;
}

export const initialState: ObterSobreState = {
    response: null,
    error: null,
};

export const ObterSobreReducer = createReducer(
    initialState,
    on(obterSobre, state => ({ ...state, error: null })),
    on(obterSobreSuccess, (state, { response }) => ({ ...state, response, error: null })),
);
